import z from "zod/v4";

export const AllowedWidth = z.union([z.literal(400), z.literal(800), z.literal(1200)]);
export type AllowedWidth = z.infer<typeof AllowedWidth>;

/** Array of allowed widths for iteration (derived from schema). */
export const ALLOWED_WIDTHS: readonly AllowedWidth[] = AllowedWidth.options.map((o) => o.value);
